;
/*!
 * subitotexto.effects.js
 */
SubitoTexto.effects = {

	init      : function () {
		var $ = jqPla,
			_this = SubitoTexto.effects;

		_this.$launchers = $( 'body' ).find( '.ne-pas-toucher-btn' );


		if ( typeof availableNePasToucher == 'undefined' || _this.$launchers.length < 1 ) {
			return;
		}

		_this.enabledEffects = [];

		for ( var i = 0; i < availableNePasToucher.length; i++ ) {
			var currType = availableNePasToucher[ i ].type;

			if ( _this.enabledEffects.indexOf( currType ) == -1 ) {
				_this.enabledEffects.push( currType );
			}
		}

		_this.currentlyPlaying = false;

		_this.bindEvents();

	},
	bindEvents: function () {
		var $ = jqPla,
			_this = SubitoTexto.effects;

		if ( !_this.currentlyPlaying ) {
			_this.$launchers.on( 'click', _this.launchRandom );


		}
	},

	launchRandom: function () {
		var $ = jqPla,
			_this = SubitoTexto.effects;

		//http://stackoverflow.com/a/5915122
		var randomChoice = availableNePasToucher[ Math.floor( Math.random() * availableNePasToucher.length ) ];

		// Seulement une campagne Google Analytics chez TFO, deux chez TQ
		// En mode TQ, la campagne a un namespace 'pla'
		var siteMode = 'mode-tfo' == $('html').attr('id') ? 'tfo' : 'tq',
			campaignSendAction = siteMode == 'tfo' ? 'send' : 'pla.send';

		if ( typeof window.ga !== 'undefined' ) {
			window.ga( campaignSendAction, 'event', {
				'eventCategory': 'Ne Pas Toucher',
				'eventAction'  : 'Cliqué',
				'eventLabel'   : randomChoice.type
			} );
		}

		if ( typeof _this[ randomChoice.type ] == 'undefined' ) {
			//console.error( '[SubitoTexto.effects] "' + randomChoice.type + '" is not a valid effect type' );
			return;
		}

		if ( typeof _this[ randomChoice.type ].init == 'function' ) {
			_this[ randomChoice.type ].init( randomChoice );
		}

		if ( typeof _this[ randomChoice.type ].launch == 'function' ) {
			//console.log( 'Launch', randomChoice );

			_this[ randomChoice.type ].launch( randomChoice );
		}

	}

};